<template>
  <div class="index-star-component">
    <ul class="stars app-flex-row-space-between">
      <li
        v-for="(item, index) in starList"
        :key="item.id"
        class="star-item app-flex-row"
        :class="{ active: activeIndex === index }"
        @click="() => starChange(index)"
      >
        <img
          v-lazy="item.avatar"
          :alt="`微博营销 达人 ${activeData.name} ${activeData.label}`"
          class="avatar"
        />
        <div class="info app-flex-column app-flex-rest font-12">
          <span class="name font-14 app-flex-row">
            {{ item.name }}
            <img
              v-lazy="require('@/assets/img/v-gold.png')"
              alt="微博营销"
              class="v-icon"
            />
          </span>
          <p>
            <span class="label">达人分类</span>
            <span>{{ item.label }}</span>
          </p>
          <p>
            <span class="label">粉丝数</span>
            <span>{{ item.fans }}</span>
          </p>
          <p>
            <span class="label">影响力</span>
            <i
              v-for="i in item.star"
              :key="i"
              class="iconfont icon-shoucangguo font-color-yellow"
            ></i>
          </p>
        </div>
      </li>
    </ul>
    <a
      v-lazy-container="{ selector: 'img' }"
      class="star-img"
      :href="starLink"
      target="_blank"
    >
      <img
        :data-src="activeData.data"
        :data-error="require('@/assets/img/loading-white.png')"
        :data-loading="require('@/assets/img/loading-white.png')"
        class="img"
        :title="`微博营销 达人推广精选推荐 ${activeData.name} ${activeData.label}`"
        :alt="`微博营销 达人推广精选推荐 ${activeData.name} ${activeData.label}`"
      />
    </a>
  </div>
</template>

<script>
import avatar1 from '@/assets/img/index-star/avatar-1.png'
import avatar2 from '@/assets/img/index-star/avatar-2.png'
import avatar3 from '@/assets/img/index-star/avatar-3.png'
import avatar4 from '@/assets/img/index-star/avatar-4.png'
import dataImg1 from '@/assets/img/index-star/data-1.png'
import dataImg2 from '@/assets/img/index-star/data-2.png'
import dataImg3 from '@/assets/img/index-star/data-3.png'
import dataImg4 from '@/assets/img/index-star/data-4.png'

export default {
  inheritAttrs: false,
  data() {
    return {
      starLink: 'https://weirenwu.weibo.com',
      activeIndex: 0,
      starList: [
        {
          id: 1,
          name: '李佳琦Austin',
          label: '美妆',
          fans: '2931W',
          star: 5,
          avatar: avatar1,
          data: dataImg1
        },
        {
          id: 2,
          name: '英国报姐',
          label: '搞笑',
          fans: '1842W',
          star: 5,
          avatar: avatar2,
          data: dataImg2
        },
        {
          id: 3,
          name: '薇娅viyaaa',
          label: '时尚',
          fans: '1826W',
          star: 5,
          avatar: avatar3,
          data: dataImg3
        },
        {
          id: 4,
          name: '日食记',
          label: '美食',
          fans: '2057W',
          star: 5,
          avatar: avatar4,
          data: dataImg4
        }
      ]
    }
  },
  computed: {
    activeData() {
      return this.starList[this.activeIndex]
    }
  },
  methods: {
    starChange(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.index-star-component {
  .stars {
    .star-item {
      width: 266px;
      height: 118px;
      border-radius: 8px;
      padding: 12px 0 0 17px;
      border: 1px solid $white;
      box-sizing: border-box;
      background: $white;
      align-items: flex-start;
      position: relative;
      cursor: pointer;
      .avatar {
        width: 68px;
        height: 68px;
        border: 2px solid #efeff3;
        margin-right: 16px;
        border-radius: 50%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .info {
        .name {
          .v-icon {
            width: 14px;
            height: 14px;
            margin-left: 4px;
          }
        }
        p {
          display: flex;
          flex-direction: row;
          .label {
            display: block;
            width: 56px;
            color: $text-color-notice;
          }
        }
      }
      &:hover {
        border-color: $text-color-primary;
      }
      &.active {
        background-color: $text-color-primary;
        border-color: $text-color-primary;
        .info {
          .name {
            color: $white;
          }
          p {
            color: $white;
            .label {
              color: $white;
            }
          }
        }
        &:after {
          content: '';
          @include triangle(top, $text-color-primary, 12px);
          bottom: 0;
          left: 50%;
          position: absolute;
          transform: translate(-50%, 100%);
        }
      }
    }
  }
  .star-img {
    display: block;
    width: 100%;
    height: 376px;
    margin-top: 28px;
    margin-bottom: 48px;
    .img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>
